export default __webpack_public_path__ + "static/media/21-pouting-face_1f621.af8528d0.png";